import { atlas } from '~/services/serviceInstances';

import {
  GetPlaybookTemplateArg,
  GetPlaybookTemplateResponse,
} from '../../types/playbooks/playbookTemplates';

export const getPlaybookTemplate = async ({
  templateId,
}: GetPlaybookTemplateArg): Promise<GetPlaybookTemplateResponse> => {
  return atlas.get(`playbooks/templates/${templateId}`);
};
